<template>
  <div class="intervention-container">
    <div class="row-container">
      <div class="row">
        <div class="row-left row-first">
          <img src="../../assets/images/desktop/list_header.svg" alt="" />
        </div>
        <div class="row-middle row-first">
          {{ uppercase(main_data.list_position.title) }}
        </div>
      </div>
      <div v-for="(elem, index) in all_keys" class="row" :key="'icon' + index" @click="$emit('navigate', [elem, true])">
        <div class="row-left">
          <img
            :src="
              require('../../assets/images/konstrukcija/desktop_pozicije/' + ('' + elem).padStart(2, '0') + '_icon.svg')
            "
            alt=""
          />
        </div>
        <div class="row-middle">
          {{ main_data.pos_position.select[elem] }}
        </div>
        <div :class="{ 'row-right': true, big: main_data.pos_status.value[elem].status === 1 }">
          <img
            v-if="main_data.pos_status.value[elem].status === 1"
            src="../../assets/images/desktop/dupla_stikla_bela_outlined.svg"
            alt=""
          />
          <img v-else src="../../assets/images/desktop/stikla_bela.svg" alt="" />
        </div>
      </div>
    </div>
    <div class="spacer"></div>
    <div class="additional">
      {{ main_data.list_additional.title }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.intervention-container {
  width: 42rem;
  height: 100%;
  background-color: $main_header_middle;
  border-radius: 5rem;
  padding: 3.5rem 2.5rem 6rem 2.5rem;
  position: relative;
  display: flex;
  flex-direction: column;

  .row-container {
    display: flex;
    flex-direction: column;

    .row {
      height: 5rem;
      max-height: 5rem;
      display: flex;
      align-items: center;
      font-size: 2.1rem;
      line-height: 0.76;
      cursor: pointer;
      margin-bottom: 3rem;

      &:first-child {
        margin-bottom: 5.5rem;
      }

      .row-left {
        // width: 9rem;
        // max-width: 9rem;
        min-width: 9rem;

        &.bottom {
          margin-left: 1rem;
        }

        img {
          max-width: 7rem;
          max-height: 6rem;
        }
      }

      .row-middle {
        flex-grow: 1;
        text-align: left;
        max-width: 20rem;

        &.row-first {
          font-family: F-Dem;
          font-size: 2.4rem;
          line-height: 1.33;
          color: $main_header_light;
        }
      }

      .row-right {
        width: 4rem;
        max-width: 4rem;
        margin-left: 1rem;
        text-align: center;

        &.big {
          img {
            width: 4rem;
            max-width: 4rem;
          }
        }

        img {
          width: 3rem;
          max-width: 3rem;
        }
      }
    }
  }

  .spacer {
    flex-grow: 1;
    border-bottom: 1px solid $main_header_light;
  }

  .additional {
    margin-top: 4.3rem;
    text-align: center;
    padding: 0 1rem;
    font-size: 2.1rem;
    font-weight: 500;
    line-height: 1.43;
    color: $main_header_light;
  }
}
</style>

<script>
import mixin from "../../lib/mixins.js";

export default {
  mixins: [mixin],
  props: ["main_data"],
  computed: {
    all_keys: function () {
      return Object.keys(this.main_data.pos_status.value).filter((elem) => elem != 10 && elem != 13 && elem != 60);
    },
  },
  methods: {},
};
</script>
